import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { reserveTicket } from '../../data/purchase-service';
import { getLabel } from '../../InitData';

function validateNumber(value) {
	const re = new RegExp('^\\+{0,1}[0-9]+$');
	return re.test(value) && !(value.length < 7 || value.length > 28);
}

function BookedBetPopup(props) {
    const betslipContext = React.useContext(BetslipContext);

    const [code, setCode] = useState(null);

    function dismiss() {
        props.dismiss();
    }

    function bookBet() {
        const coupon = betslipContext.betslipData.coupons[betslipContext.betslipData.selectedCoupon];
        reserveTicket(coupon, betslipContext.user.sessionToken, inputRef.current.value, (data) =>{
            if (data != null) {
                if (data.code === 0) { 			 	
                    setCode(data.description);
                }
            }
        }, () => {
            setError(getLabel('general.error'));
            setTimeout(() => {
                inputRef.current.focus();
                setError(null);
            }, 1000);
        });
    }

    const inputRef = useRef(null);
    function validateInput() {
        if (inputRef && !validateNumber(inputRef.current.value)) {
            setError(getLabel('book_bet_popup.invalid_number'));
            setTimeout(() => {
                inputRef.current.focus();
                setError(null);
            }, 1000);
        } else {
            bookBet();
        }
    }

    const [error, setError] = useState('');

    const container = document.getElementById('popup-container');
    if (container == null) {
        return;
    }

    return ReactDOM.createPortal(
        <div className="customPopup">
            <div className="customPopup__content">
                <div className="customPopup__content__header">
                    <div className="customPopup__content__header__title">
                        <p>{getLabel('book_bet_popup.title')}</p>
                    </div>
                    <button className="customPopup__content__header__closeButton" onClick={dismiss}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                <div className="customPopup__content__body">
                    {code == null ?
                        <>
                            <p>{getLabel('book_bet_popup.text')}</p>
                            <input type="text" className="form-control mt-2" autoFocus ref={inputRef} />
                            <hr />
                            <div className="d-flex justify-content-between align-items-center">
                                {!error ?
                                    <button className="customPopup__content__body__clickable customPopup__content__body__clickable--success" onClick={validateInput}>{getLabel('book_bet_popup.confirm_btn')}</button>
                                    :
                                    <button className="font-weight-bold text-danger">{error}</button>
                                }
                                <button className="customPopup__content__body__clickable customPopup__content__body__clickable--success" onClick={dismiss}>{getLabel('book_bet_popup.dismiss_btn')}</button>
                            </div>
                        </>
                        :
                        <>
                            <p>Scommessa prenotata ({code}).</p>
                            <hr />
                            <button className="customPopup__content__body__clickable customPopup__content__body__clickable--success" onClick={dismiss}>{getLabel('book_bet_popup.success_btn')}</button>
                        </>
                    }
                </div>
            </div>
        </div>,
        container
    );
}

export default BookedBetPopup;